<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (loading) {
    <div class="loader"></div>
  }
  @if (!loading) {
    <div class="modal-container">
      @if (!service) {
        <h1>{{'Add service' | translate}}</h1>
      }
      @if (service) {
        <h1>{{'Edit service' | translate}}</h1>
      }
      @if (error) {
        <div class="errorMessage">{{ error | translate}}</div>
      }
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        @if (categories) {
          <div class="L-12 M-12 S-12 columns" [ngClass]="{'L-12 M-12 S-12': hasShooting, 'L-5 M-5 S-5': !hasShooting}">
            <label>{{'Category' | translate}}**</label>
            <app-dropdown
              [(appModel)]="formData.service_category_id"
              [list]="categories"
              [value]="'id'"
              [name]="'category_name'"
              [backTranslate]="true"
            ></app-dropdown>
          </div>
        }
        @if (!hasShooting) {
          <div class="L-4 M-4 S-4 columns">
            <label>{{'Date' | translate}}**</label>
            <input type="date" name="date" [(ngModel)]="formData.date" required>
          </div>
        }
        @if (!hasShooting && lists.units) {
          <div class="L-3 M-3 S-3 columns">
            <label>{{'Unit' | translate}}</label>
            <app-dropdown
              [(appModel)]="formData.unit_id"
              [list]="lists.units"
              [value]="'id'"
              [name]="'unit_name'"
              [multiple]="false"
            ></app-dropdown>
          </div>
        }
        <div class="L-8 M-8 S-8 columns">
          <label for="service-description">{{'Description' | translate}}**</label>
          <input id="service-description" type="text" name="description" [(ngModel)]="formData.description" required>
        </div>
        <div class="L-4 M-4 S-4 columns">
          <label for="service-quantity">{{'Quantity' | translate}}**</label>
          <input id="service-quantity" class="centered" type="text" name="quantity" [(ngModel)]="formData.quantity"  pattern="[\d]{1,4}" required>
        </div>
        <div class="L-8 M-8 S-8 columns">
          <label for="service-vendor">{{'Vendor' | translate}}</label>
          <input id="service-vendor" type="text" name="vendor" [(ngModel)]="formData.vendor">
        </div>
        <div class="L-4 M-4 S-4 columns">
          <label for="service-nit">{{'Nit' | translate}}</label>
          <input id="service-nit" class="centered" type="text" name="nit" [(ngModel)]="formData.nit">
        </div>
        @if (shooting) {
          <div class="L-5 M-5 S-5 columns" [ngClass]="{'L-8 M-8 S-8' : showFields(), 'L-5 M-5 S-5': !showFields()}">
            <label for="service-contact-person">{{'Contact person' | translate}}</label>
            <input id="service-contact-person" type="text" name="contact_person" [(ngModel)]="formData.contact_person">
          </div>
          <div class="L-4 M-4 S-4 columns">
            <label for="service-contact-phone">{{'Contact phone' | translate}}</label>
            <input id="service-contact-phone" class="centered" type="text" name="contact_phone" [(ngModel)]="formData.contact_phone"  pattern="[\d]{1,16}">
          </div>
        }
        <div class="L-12 M-12 S-12 columns" >
          <label for="service-call-place">{{'Call place' | translate}}</label>
          <input id="service-call-place" class="centered" type="text" name="call_place" [(ngModel)]="formData.call_place">
        </div>
        <div class="columns" [ngClass]="{'L-4 M-4 S-4' : showFields(), 'L-3 M-3 S-3': !showFields()}">
          <label for="service-call-time">{{'On location' | translate}}</label>
          <input id="service-call-time" class="centered" type="time" name="call_time" [(ngModel)]="formData.call_time">
        </div>
        @if (showFields()) {
          <div class="L-4 M-4 S-4 columns">
            <label for="service-arrive">{{'Arrive' | translate}}</label>
            <input id="service-arrive" class="centered" type="time" name="arrive" [(ngModel)]="formData.arrive">
          </div>
          <div class="L-4 M-4 S-4 columns">
            <label for="service-wrap">{{'Wrap' | translate}}</label>
            <input id="service-wrap" class="centered" type="time" name="wrap" [(ngModel)]="formData.wrap">
          </div>
          <div class="L-3 M-3 S-3 columns">
            <label for="service-cost-unit">{{'Unit cost' | translate}}</label>
            <input id="service-cost-unit" currencyMask type="text" name="cost_unit" [(ngModel)]="formData.cost_unit">
          </div>
          <div class="L-3 M-3 S-3 columns">
            <label for="service-lunch">{{'Lunch' | translate}}</label>
            <input id="service-lunch" currencyMask type="text" name="lunch" [(ngModel)]="formData.lunch">
          </div>
          <div class="L-3 M-3 S-3 columns">
            <label for="service-extra">{{'H extra' | translate}}</label>
            <input id="service-extra" currencyMask type="text" name="extra" [(ngModel)]="formData.extra">
          </div>
          <div class="L-3 M-3 S-3 columns">
            <label for="service-periphery">{{'Periphery' | translate}}</label>
            <input id="service-periphery" currencyMask type="text" name="periphery" [(ngModel)]="formData.periphery">
          </div>
          @if (!shooting) {
            <div class="L-6 M-6 S-6 columns">
              <label for="service-invoice">{{'Invoice' | translate}}</label>
              <input id="service-invoice" class="centered" type="text" name="invoice" [(ngModel)]="formData.invoice">
            </div>
          }
          <div class="columns" [ngClass]="{'L-8 M-8 S-8 ': shooting, 'L-12 M-12 S-12': !shooting}">
            <label for="service-observation">{{'Observation' | translate}}</label>
            <input id="service-observation" type="text" name="observation" [(ngModel)]="formData.observation">
          </div>
        }
        <div class="L-12 M-12 S-12 columns">
          <input type="checkbox" name="monthly" [(ngModel)]="formData.monthly">
          <p class="checkbox">{{'Monthly service' | translate}}</p>
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>
